import { getLogger } from "@goodgamestudios/logger";
import Container = createjs.Container;

const logger = getLogger("BasicHandleServerErrorCommand");

export class Siren24ViewUtil {
    static get ageRatingLogo(): Container {
        logger.warn("Siren24ViewUtil.ageRatingLogo is not implemented");
        return new Container();
    }

    static get contentDescriptorLogo(): Container {
        logger.warn("Siren24ViewUtil.contentDescriptorLogo is not implemented");
        return new Container();
    }

    static get licenceTable(): Container {
        logger.warn("Siren24ViewUtil.licenceTable is not implemented");
        return new Container();
    }
}
